export default __webpack_public_path__ + "static/media/SettingInactive.4b29a612.svg";